import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery, sectionMargins, fontSize } from '../styles';
import { Container, HtmlContent, Link } from './ui';
import eyeIcon from '../images/eye-icon.bg.svg';

const StyledContentLinksList = styled.section`
  ${sectionMargins()};
`;

const StyledItems = styled.ul`
  margin-top: 15px;
  column-count: 2;
  column-gap: 20px;

  ${minBreakpointQuery.small`
    margin-top: 20px;
  `}

  ${minBreakpointQuery.medium`
    column-count: 3;
  `}

  ${minBreakpointQuery.large`
    margin-top: 25px;
  `}
`;

const StyledItem = styled.li`
  margin-bottom: 8px;
  padding-left: 26px;
  background: url(${eyeIcon}) no-repeat 0 4px / 16px 12px;

  ${minBreakpointQuery.small`
    margin-bottom: 10px;
    background-position-y: 6px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 12px;
    background-position-y: 8px;
  `}
`;

const StyledLink = styled(Link)`
  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}

  ${minBreakpointQuery.large`
    ${fontSize(20)};
  `}
`;

const ContentLinksList = ({ content, links }) =>
  links.length > 0 && (
    <StyledContentLinksList>
      <Container narrow={true}>
        <HtmlContent html={content} />
        <StyledItems>
          {links.map(({ name, url }, id) => (
            <StyledItem key={id}>
              <StyledLink to={url}>{name}</StyledLink>
            </StyledItem>
          ))}
        </StyledItems>
      </Container>
    </StyledContentLinksList>
  );

export default ContentLinksList;
